import { createSelector } from "@ngrx/store";
import { LevelStoreSelectors } from "../components/level/store";

export const selectIsLoading = createSelector(
  LevelStoreSelectors.selectIsLoading,
  (...isLoadings) => isLoadings.find((isLoading) => isLoading)
);
